import { render, staticRenderFns } from "./form-sbm.vue?vue&type=template&id=583c27b6"
import script from "./form-sbm.vue?vue&type=script&lang=js"
export * from "./form-sbm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports